<div class="aca-flow" tabindex="0" (keydown)="onKey($event)" [attr.aria-label]="'DMS.FLOW.CANVAS' | translate">
  <div
    #plane
    class="aca-flow__plane"
    [style.width.px]="planeWidth"
    [style.height.px]="planeHeight"
    (pointerdown)="onBackgroundDown()"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointerleave)="onPointerUp($event)"
  >
    <svg class="aca-flow__edges" [attr.width]="planeWidth" [attr.height]="planeHeight">
      <defs>
        <marker id="aca-flow-arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
          <path d="M 0 0 L 10 5 L 0 10 z" class="aca-flow__arrowhead" />
        </marker>
      </defs>
      <g
        *ngFor="let d of drawnEdges(); trackBy: trackEdge"
        class="aca-flow__edge"
        [ngClass]="'aca-flow__edge--' + d.tone"
        [class.aca-flow__edge--on]="isSelected('edge', d.edge.id)"
        [class.aca-flow__edge--bad]="edgeHasProblem(d.edge)"
      >
        <path class="aca-flow__hit" [attr.d]="d.path" (pointerdown)="selectEdge($event, d.edge)" />
        <path class="aca-flow__line" [attr.d]="d.path" marker-end="url(#aca-flow-arrow)" />
      </g>
      <line
        *ngIf="linking as l"
        class="aca-flow__linking"
        [attr.x1]="l.from.x + nodeWidth / 2"
        [attr.y1]="l.from.y + nodeHeight"
        [attr.x2]="l.x"
        [attr.y2]="l.y"
      />
    </svg>

    <ng-container *ngFor="let d of drawnEdges(); trackBy: trackEdge">
      <button
        type="button"
        *ngIf="d.label"
        class="aca-flow__label"
        [ngClass]="'aca-flow__label--' + d.tone"
        [style.left.px]="d.labelX"
        [style.top.px]="d.labelY"
        (pointerdown)="selectEdge($event, d.edge)"
      >
        {{ d.label }}
      </button>
    </ng-container>

    <div
      *ngFor="let node of graph.nodes; trackBy: trackNode"
      class="aca-flow__node"
      [ngClass]="'aca-flow__node--' + node.kind"
      [class.aca-flow__node--on]="isSelected('node', node.id)"
      [class.aca-flow__node--bad]="hasProblem(node)"
      [style.left.px]="node.x"
      [style.top.px]="node.y"
      [style.width.px]="nodeWidth"
      [style.height.px]="nodeHeight"
      role="button"
      tabindex="-1"
      [attr.aria-label]="node.name"
      (pointerdown)="onNodeDown($event, node)"
    >
      <span class="aca-flow__icon"
        ><mat-icon>{{ icons[node.kind] }}</mat-icon></span
      >
      <span class="aca-flow__text">
        <span class="aca-flow__name">{{ node.name || ('DMS.FLOW.KIND_' + (node.kind | uppercase) | translate) }}</span>
        <span class="aca-flow__sub" *ngIf="subtitle(node) as sub">{{ sub }}</span>
      </span>
      <span
        *ngIf="node.kind !== 'end'"
        class="aca-flow__port"
        [attr.aria-label]="'DMS.FLOW.CONNECT' | translate"
        [title]="'DMS.FLOW.CONNECT' | translate"
        (pointerdown)="onPortDown($event, node)"
      ></span>
    </div>
  </div>
</div>
